/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free cron expression explainer. Paste a crontab schedule and get a plain-English description with a field-by-field breakdown. Runs in your browser.`)
};

const es_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expresiones cron. Pega un horario de crontab y obtén una descripción en lenguaje plano con un desglose campo por campo. Se ejecuta en tu navegador.`)
};

const de_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Cron-Ausdruck-Erklärer. Fügen Sie einen Crontab-Zeitplan ein und erhalten Sie eine leicht verständliche Beschreibung samt Aufschlüsselung Feld für Feld. Läuft direkt in Ihrem Browser.`)
};

const nl_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis cron-expressie verklaarder. Plak een crontab-schema en krijg een duidelijke beschrijving in het Nederlands met een afbraak per veld. Werkt in uw browser.`)
};

const fr_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expliciteur gratuit d'expressions cron. Collez un horaire crontab et obtenez une description en langage courant avec une décomposition champ par champ. Fonctionne dans votre navigateur.`)
};

const it_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiegatore gratuito di espressioni cron. Incolla una pianificazione crontab e ottieni una descrizione in italiano semplice con una suddivisione campo per campo. Funziona nel tuo browser.`)
};

const pt_br2_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expressões cron. Cole um cronograma crontab e obtenha uma descrição em linguagem clara com um detalhamento campo a campo. Funciona no seu navegador.`)
};

const pt_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador gratuito de expressões cron. Cole um agendamento crontab e obtenha uma descrição em português claro com uma decomposição campo a campo. Funciona no seu navegador.`)
};

const ja_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のcron式エクスプレーナー。crontabスケジュールをペーストすると、平文の説明とフィールド単位の分解が得られます。ブラウザで実行されます。`)
};

const zh_cr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 Cron 表达式解释器。粘贴一个 crontab 计划，即可获得通俗易懂的说明以及逐字段解析。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_tool_description", locale)
	if (locale === "en") return en_cr_tool_description(inputs)
	if (locale === "es") return es_cr_tool_description(inputs)
	if (locale === "de") return de_cr_tool_description(inputs)
	if (locale === "nl") return nl_cr_tool_description(inputs)
	if (locale === "fr") return fr_cr_tool_description(inputs)
	if (locale === "it") return it_cr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cr_tool_description(inputs)
	if (locale === "pt") return pt_cr_tool_description(inputs)
	if (locale === "ja") return ja_cr_tool_description(inputs)
	return zh_cr_tool_description(inputs)
};